export default __webpack_public_path__ + "static/media/item-thumbnail2.aeaff946.png";